module.exports = __webpack_public_path__ + "static/media/my-personal-information.1b8a6ae2.svg";